import addDotsToPrice from "../price-format";

const BillRow = ({ item, sizeInfo, quantity }) => {
  return (
    <tr className="border-bottom">
      <td>{item._id}</td>
      <td>
        <img src={item.img1} alt={item.name} className="m-2" />
      </td>
      <td>{item.name}</td>
      <td>{sizeInfo}</td>
      <td>{addDotsToPrice(item.price)}</td>
      <td>{quantity}</td>
    </tr>
  );
};

export default BillRow;
